<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>用户列表</b></p>

        </div>

        <el-table :data="userList" style="width: 100%" highlight-current-row>
            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column prop="username" label="用户" min-width="30%">
            </el-table-column>
            <el-table-column prop="phone" label="智模号" min-width="25%">
            </el-table-column>

            <!-- <el-table-column prop="companyName" label="所属公司" min-width="25%">
            </el-table-column> -->

            <el-table-column prop="createdTime" label="注册日期" min-width="25%">
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="20%">
            </el-table-column>

            <!-- <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        编辑
                    </el-button>
                    
                </template>
            </el-table-column> -->
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div>

        <!-- <el-dialog title="租户详情" :visible.sync="dialogFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">
                <el-form-item label="租户" required :label-width="formLabelWidth">
                    <el-input v-model="form.companyName" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="用户" required :label-width="formLabelWidth" prop="username">
                    <el-input v-model="form.username" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="智模号" required :label-width="formLabelWidth" prop="phone">
                    <el-input v-model="form.phone" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="创建日期" required :label-width="formLabelWidth" prop="createdTime">
                    <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期" disabled>
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="有效期" required :label-width="formLabelWidth" prop="expireTime">
                    <el-date-picker v-model="form.expireTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <div style="width:350px;display: inline-block;"></div>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => editCompany('ruleForm')">保存</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
export default {
    name: "userAdmin",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),
            userList: [],
            dialogFormVisible: false,

            form: {
                id: '',
                companyName: '大公司',
                username: '老板',
                phone: '18888888888',

                createdTime: new Date(),
                expireTime: '',
                status: 0,

            },

            formLabelWidth: '120px',

            rules: {
                expireTime: [
                    { required: true, message: '请选择有效期', trigger: 'blur' },
                    { required: true, message: '请选择有效期', trigger: 'change' }
                ]
            },
            pageIndex:0,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        // handleClick(row) {
        //     // console.log(row);
        //     this.form.id = row.id
        //     //this.saveButtonVisible1 = false
        //     //this.saveButtonVisible2 = true

        //     this.form.companyName = row.companyName
        //     this.form.username = row.username
        //     this.form.phone = row.phone

        //     this.form.createdTime = row.createdTime
        //     this.form.expireTime = row.expireTime
        //     this.form.status = null
        //     // this.form.remark = row.remark

        //     // this.moldCodeDisable = true
        //     this.dialogFormVisible = true
        // },
        // editCompany(formName) {
        //     this.$refs[formName].validate((valid) => {
        //         if (valid) {
        //             // alert('submit!');
        //             this.$axios({
        //                 method: "post",
        //                 url: "/shiro/company/modify",
        //                 data: {
        //                     id: this.form.id,

        //                     expireTime: this.form.expireTime
        //                 }, headers: {
        //                     token: this.token
        //                 }
        //             }).then(result => {

        //                 const data = result.data

        //                 this.$message(data.msg)

        //                 this.dialogFormVisible = false
        //                 this.getAll()
        //             })
        //         } else {
        //             // console.log('error submit!!');
        //             return false;
        //         }
        //     });

        // },
        getAll() {

            const formData = new FormData()

            formData.append('id', this.userId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', 10)

            this.$axios({
                method: "post",
                url: "/shiro/user/all",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status == 400 || data.status == 401) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    });
                    this.$router.push({ path: "/Login" });
                }

                this.userList = data.data
                this.total = this.userList[0].total
                // this.pageCount = this.total % 10 == 0 ? this.total % 10 : this.total % 10 + 1

                for (let i in this.userList) {
                    this.userList[i].createdTime = this.$moment(this.userList[i].createdTime).format("YYYY-MM-DD")

                    if (this.userList[i].status == 0) {
                        this.userList[i].status = '禁用'
                    } else if (this.userList[i].status == 1) {
                        this.userList[i].status = '启用'
                    }
                }
            })
        },
        pageClick(currentPage) {
            // console.log('pageClick()')
            // console.log(currentPage)
            this.pageIndex = (currentPage - 1) * 10
            this.getAll()
        }
    },
    mounted() {
        this.getAll()

    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>